module.exports = __webpack_public_path__ + "img/zwei_symetrische_lasten.190078b2.png";